import React, { Component } from 'react';
import { Spin } from 'antd'
import Charts from './Charts';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import Filter from './Filter';
import {defaultDate} from "../../../../../common/jsLibs";
import moment from 'moment';

class HistogramBrokenLine extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            searchParams: this.props.searchParams||{},
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { searchParams } = this.state;
        const defaultDateObj = defaultDate();
        const{beginDateDefault,endDateDefault}=defaultDateObj;
        const {
            beginDate,
            endDate,
        } = searchParams;
        this.setState({ loading: true });
        Fetch.post(API_URL.home.queryBAHistogram, {
            beginDate:beginDate?beginDate:beginDateDefault,
            endDate:endDate?endDate:endDateDefault,
            ...searchParams,
        }).then(res => {
            const { canApplyAmountList,canNotApplyAmountList,grossAmountList,receivingAmountList } = res;
            this.setState({
                canApplyAmountList,
                canNotApplyAmountList,
                grossAmountList,
                receivingAmountList,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    search = () => {
        this.loadData();
    }

    render() {
        const { clientHeight } = this.props;
        const { loading,
            canApplyAmountList,
            canNotApplyAmountList,
            grossAmountList,
            receivingAmountList,
        } = this.state;
        const height = clientHeight - 72;
        const { searchParams } = this.state;
        const defaultDateObj = defaultDate();
        const{beginDateDefault,endDateDefault}=defaultDateObj;
        const {
            beginDate,
            endDate,
        } = searchParams;
        return (
            <div className="pane-item-content">
                <Filter
                    search={this.search}
                    searchParams={searchParams}
                    onChange={this.handleFilterChange}
                />
                <Spin spinning={loading}>
                    <Charts
                     canApplyAmountList={canApplyAmountList}
                     canNotApplyAmountList={canNotApplyAmountList}
                     grossAmountList={grossAmountList}
                     receivingAmountList={receivingAmountList}
                     height={height}
                     searchParams={searchParams}
                     filename={`请款报表(${moment(beginDate?beginDate:beginDateDefault).format("YYYYMM")}-${moment(endDate?endDate:endDateDefault).format("YYYYMM")})`}
                     />
                </Spin>
            </div>
        );
    }
}

export default HistogramBrokenLine;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/RequestSheet/HistogramBrokenLine/index.js